<mat-card *ngIf="echoModel?.deleted" class="rp-mobile">
  This post was probably deleted by the author.
</mat-card>

<mat-card *ngIf="!echoModel?.deleted" class="p-2 rp-mobile">
  <div class="d-flex">
    <!-- Profile Picture -->
    <div class="tl-tooltip-wrap tl-no-focus">
      <div class="pr-cursor">
        <img [src]="echoModel?.author?.photoURL?.trim() || './assets/images/profile.jpg'" alt="avatar"
             class="tl-profile pr-cursor" (mouseenter)="showProfileCard()"
             [routerLink]="['/', echoModel?.author?.handle]"/>
      </div>
      <div class="tl-tooltip-content" *ngIf="showProfileCardEvent$ | async">
        <anms-profile-card [lightUser]="echoModel?.author" [currentUser]="currentUser$ | async"></anms-profile-card>
      </div>
    </div>
    <!-- Name -->
    <div>
      <div class="pr-cursor tl-tooltip-wrap tl-no-focus" [routerLink]="['/', echoModel?.author?.handle]">
        <span class="tl-name mr-1">{{echoModel?.author?.name}}</span>
        <span class="tl-username text-success tl-truncate">@{{echoModel?.author?.handle}}</span>
        <div class="tl-tooltip-content">
          <div>
            <!--            <anms-profile-card [lightUser]="echoModel?.author" [currentUser]="currentUser$ | async">-->
            <!--            </anms-profile-card>-->
          </div>
        </div>
      </div>
      <!-- Published Date -->
      <div class="tl-date">
        <i class="fas fa-clock mr-1"></i>
        <span>
          <!--  May 1, 2020. 10:00 AM-->
          {{echoModel?.lastEdited | postTime}}
        </span>
      </div>
    </div>
  </div>

  <!-- Post Content -->
  <div *ngIf="echoModel?.postType !== 'POLL'">
    <h5 class="tl-title pr-cursor">{{echoModel?.articleContent?.title}}</h5>
    <p *ngIf="echoModel?.postType !== 'POLL'" class="tl-post pr-cursor">
      <read-article class="wrap-overflow">
        <markdown ngPreserveWhitespaces *ngIf="echoModel" (click)="postClicked($event)">
          {{parseBody(echoModel?.body).body}}
        </markdown>
      </read-article>
    </p>

    <preview-url *ngIf="lastUrl" [url]="lastUrl"></preview-url>

    <!--    <ng-container>-->
    <!--      <ngx-link-preview class="modern"-->
    <!--                        [links]="['https://en.wikipedia.org/wiki/Kenya']"-->
    <!--                        [apiRoute]="'https://play.dhis2.org/demo/api/metadata'"-->
    <!--                        [getApiEndpoint$]="apiCallbackFn">-->
    <!--        <h2>Here can be your custom loading spinner</h2>-->
    <!--      </ngx-link-preview>-->
    <!--    </ng-container>-->

    <div>
      <vg-player *ngFor="let v of echoModel?.videos" class="overlay-container">
        <video #media [vgMedia]="media" id="singleVideo" preload="auto" controls>
          <source [src]="v?.url" type="video/mp4">
        </video>
        <div class="overlay-btn" *ngIf="(currentUser$ | async)?.ID === null" matTooltip="PLEASE LOGIN TO PLAY" matTooltipPosition="below">
          <button mat-fab color="primary" aria-label="Login to Play" style="margin-bottom: 25px" matTooltip="Login To Play" matTooltipPosition="after">
            <mat-icon>play_arrow</mat-icon>
          </button>
        </div>
      </vg-player>
    </div>

    <div class="pr-cursor" [class.img-wrapper]="echoModel?.images?.length > 1" [class.img-wrapper3]="echoModel?.images?.length === 3">
      <img class="img-size img-single" *ngFor="let photo of echoModel?.images; index as i" [src]="photo?.url"
           alt="post image" width="100%" (click)="open(i)"/>
    </div>

    <div class="pr-cursor" [class.img-wrapper]="echoModel?.images?.length > 1" [class.img-wrapper3]="echoModel?.images?.length === 3">
      <img class="img-size img-single"
           *ngFor="let photo of (echoModel && parseBody(echoModel?.body).images); index as i" [src]="photo"
           alt="post image" width="100%" (click)="open(i)"/>
    </div>
  </div>
  <!--  end of post content-->

  <!--  poll design - section-->
  <div class="" *ngIf="echoModel?.postType === 'POLL'"
       [routerLink]="['/', echoModel.author.handle, 'post', echoModel.Id]">

    <!-- <h5 class="tl-title">Conditional Post Title - For Blog Posts Only</h5> -->
    <p class="tl-post pr-cursor" (click)="postClicked($event)">
      {{echoModel?.pollContent?.question}}
    </p>
    <!-- Poll -->
    <!-- On CLick It Should Display Poll Results -->
    <div class="tl-poll-vote">
      <mat-radio-group aria-label="Select an option" class="tl-poll-group"
                       *ngIf="!(echoModel?.pollContent?.expiry | pollExpired) && (echoModel?.myPollVote === null)">
        <mat-radio-button value="{{i}}" class="tl-poll-button"
                          *ngFor="let answer of echoModel?.pollContent?.answers; let i = index">
          {{answer.answer}}
        </mat-radio-button>
      </mat-radio-group>
    </div>
    <!-- Poll Results - To Be Activated by Voting -->
    <div class="tl-poll-results"
         *ngIf="(echoModel?.myPollVote !== null) || (echoModel?.pollContent?.expiry | pollExpired)">
      <div class="d-flex tl-poll" *ngFor="let answer of echoModel?.pollContent?.answers; let i = index">
        <span
          class="tl-poll-percentage">{{answer.votes | pollCalculatePercentage : echoModel?.pollContent?.totalVotes}}
          %</span>
        <div class="tl-poll-bar">
          <span class="tl-poll-option">{{answer?.answer}}</span>
          <mat-progress-bar mode="determinate"
                            [value]="answer.votes | pollCalculatePercentage : echoModel?.pollContent?.totalVotes"
                            class="tl-poll-display"></mat-progress-bar>
        </div>
        <span matTooltip="You voted for this" matTooltipPosition="before" *ngIf="echoModel?.myPollVote === i">
          <i class="fa fa-check-circle tl-voted" aria-hidden="true"></i></span>
      </div>
    </div>

    <div class="tl-poll-meta">
      <i class="fas fa-users mr-1"></i>
      <span>{{echoModel?.pollContent?.totalVotes}} Votes</span>
      <i class="fas fa-stopwatch mr-1 ml-1"></i>
      <span>{{echoModel?.pollContent?.expiry | pollCountDown}}</span>
    </div>
  </div>


  <!--  end of poll design-->
</mat-card>
